"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderStatusCode = void 0;
var OrderStatusCode;
(function (OrderStatusCode) {
    OrderStatusCode[OrderStatusCode["DRAFT"] = -1] = "DRAFT";
    OrderStatusCode[OrderStatusCode["PENDING"] = 1] = "PENDING";
    OrderStatusCode[OrderStatusCode["CONFIRMED"] = 2] = "CONFIRMED";
    OrderStatusCode[OrderStatusCode["BOOKED"] = 3] = "BOOKED";
    OrderStatusCode[OrderStatusCode["DROPPED"] = 15] = "DROPPED";
    OrderStatusCode[OrderStatusCode["FINISHED"] = 4] = "FINISHED";
    OrderStatusCode[OrderStatusCode["COMPLETED"] = 5] = "COMPLETED";
    OrderStatusCode[OrderStatusCode["CLOSED"] = 6] = "CLOSED";
    OrderStatusCode[OrderStatusCode["CANCELED_WITHOUT_FEE"] = 7] = "CANCELED_WITHOUT_FEE";
    OrderStatusCode[OrderStatusCode["CANCELED_WITH_FEE"] = 8] = "CANCELED_WITH_FEE";
    OrderStatusCode[OrderStatusCode["CANCELED_BY_WH"] = 9] = "CANCELED_BY_WH";
    OrderStatusCode[OrderStatusCode["DELETED_DRAFT"] = 16] = "DELETED_DRAFT";
    OrderStatusCode[OrderStatusCode["EXPIRED"] = 10] = "EXPIRED";
    OrderStatusCode[OrderStatusCode["LTW_PENDING"] = 11] = "LTW_PENDING";
    OrderStatusCode[OrderStatusCode["LTW_CANCELED"] = 12] = "LTW_CANCELED";
})(OrderStatusCode = exports.OrderStatusCode || (exports.OrderStatusCode = {}));
